import {useDispatch, useSelector} from "react-redux";
import {saveLocalStorage} from "./useLocalStorage";
import {Types as userInfoTypes} from "store/reducers/userInfoReducer";
import {KeycloakLoginReturn} from "services/api_v2/Auth/auth.service";

const useAuthSession = () => {
  const dispatch = useDispatch();
  const {userInfo} = useSelector((state: any) => state.stateUserInfo);

  const setAuthSession = (authData: KeycloakLoginReturn<unknown>) => {
    //Código comentado por conta da inativação da chamada pra homolog do cp
    // const {data: cpData} = await GetAccessTokenByRefreshToken(
    //   userCPData?.refreshToken,
    // );
    // saveLocalStorage("userinfo", {
    //   ...userCPData,
    //   accessToken: cpData.accessToken,
    //   refreshToken: cpData.refreshToken,
    // });

    saveLocalStorage("ownerProfile", authData);
    saveLocalStorage("refreshToken", authData.access_token);

    dispatch({
      type: userInfoTypes.SET_USER_INFO,
      userInfo: {...userInfo, ...authData},
    });
  };
  return {setAuthSession};
};

export default useAuthSession;
